import SMConst from 'lib/SMConst';

class SMCalendarHelper {
  
  static cellItemToDate(calendarDayItem){
    // itemDateはrailsからのデータのため1引く
    return new Date(parseInt(calendarDayItem.year), 
                    parseInt(calendarDayItem.month) - 1, 
                    parseInt(calendarDayItem.day));
  }
  
  static isWeekEnd(item) {
    var itemDate = this.cellItemToDate(item);
    if (itemDate.getDay() == 0 || itemDate.getDay() == 6) {
      return true;
    } else {
      return false;
    }
  }
  
  static isClosed(item) {
    if (item.status == SMConst.RoomStatus.Close) {
      return true;
    } else {
      return false;
    }
  }

  static isPast(item, today) {
    var itemDate = this.cellItemToDate(item);
    if (today.getTime() > itemDate.getTime()) {
      return true;
    } else {
      return false;
    }
  }

  static isToday(item, today) {
    var itemDate = this.cellItemToDate(item);
    if (today.getTime() == itemDate.getTime()) {
      return true;
    } else {
      return false;
    }
  }

  static isNextMonth(displayMonthDate, itemDate) {
    if (displayMonthDate.getTime() < itemDate.getTime() && displayMonthDate.getMonth() != itemDate.getMonth()) {
      return true;
    } else {
      return false;
    }
  }
  
  static isPrevMonth(displayMonthDate, itemDate) {
    if (displayMonthDate.getTime() > itemDate.getTime() && displayMonthDate.getMonth() != itemDate.getMonth()) {
      return true;
    } else {
      return false;
    }
  }
  
  static cellClassName(item, year, month, today){
    var displayMonthDate = new Date(year, month, 1),
        itemDate = this.cellItemToDate(item),
        cellClassName = '',
        isClosed = this.isClosed(item),
        isPast = false;
    
    if (this.isPast(item, today)) {
      isPast = true;
      isClosed = false;
    }
    
    if (this.isPrevMonth(displayMonthDate, itemDate) || this.isNextMonth(displayMonthDate, itemDate) || isPast) {
      cellClassName += ' is-past';
    }
    if (this.isWeekEnd(item)) {
      cellClassName += ' is-holiday';
    }
    if (isClosed) {
      cellClassName += ' is-closed';
    }
    if (this.isToday(item, today)) {
      cellClassName += ' is-today';
    }
    
    return cellClassName;
  }
  
}
export default SMCalendarHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMCalendarHelper.js